export class GlobalRef<T> {
  private readonly sym: symbol;

  constructor(id: string) {
    this.sym = Symbol.for(id);
  }

  getValue(): T | undefined {
    return (this.getGlobal() as Record<symbol, T>)[this.sym];
  }

  setValue(value: T) {
    (this.getGlobal() as Record<symbol, T>)[this.sym] = value;
  }

  private getGlobal() {
    return typeof window === 'undefined' ? global : window;
  }
}
